import PromiseCreator from 'promise-creator';
import { takeEvery, call, put } from 'redux-saga/effects';
import { SubmissionError } from 'redux-form';
import { combineReducers } from 'redux';
import { delay } from 'redux-saga';
import request from '../api-utils/request';
import actionKey from '../utils/action-key';
import { showAlert } from './alert';
import { openPromptAction, closePromptAction, showPromptErrorAction } from './prompt';
import { changeFilterAction } from './users-search';

export const REMOVE_USER_FROM_COMPANY = 'admin/REMOVE_USER_FROM_COMPANY';
export const ADD_USER = 'admin/ADD_USER';
export const VALIDATE_USER = 'admin/VALIDATE_USER';
export const DELETE_USER = 'admin/DELETE_USER';
export const MOVE_USER = 'admin/MOVE_USER';
export const INVITE_USER = 'admin/INVITE_USER';
export const SEARCH_DOMAIN = 'admin/SEARCH_DOMAIN';
export const SEND_FORM = 'admin/SEND_FORM';
export const EDIT_USER = 'admin/EDIT_USER';
export const REFRESH_LIST = 'admin/REFRESH_LIST';
export const GET_USER = 'admin/GET_USER';
export const SET_BANNER = 'admin/SET_BANNER';

export const removeUserFromCompanyAction = user => ({
    type: REMOVE_USER_FROM_COMPANY,
    user,
});

export const validateUserAction = ({ body, resolve, reject }) => ({
    type: VALIDATE_USER,
    resolve,
    reject,
    body,
});

export const deleteUserAction = ({ body, resolve, reject }) => ({
    type: DELETE_USER,
    resolve,
    reject,
    body,
});

export const addUserAction = ({ body, resolve, reject }) => ({
    type: ADD_USER,
    resolve,
    reject,
    body,
});

export const inviteUserAction = ({ body, resolve, reject }) => ({
    type: INVITE_USER,
    resolve,
    reject,
    body,
});

export const sendFormAction = ({ body, resolve, reject, id }) => ({
    type: SEND_FORM,
    resolve,
    reject,
    body,
    id,
});

export const editUserAction = ({ body, resolve, reject, id }) => ({
    type: EDIT_USER,
    resolve,
    reject,
    body,
    id,
});

export const getUserAction = userId => ({
    type: GET_USER,
    userId,
});

export const searchDomainAction = (payload, { resolve, reject } = {}) => ({
    type: SEARCH_DOMAIN,
    payload,
    resolve,
    reject,
});

export const moveUserAction = ({ body, resolve, reject } = {}) => ({
    type: MOVE_USER,
    resolve,
    reject,
    body,
});

export const setBannerAction = ({ body, resolve, reject }) => ({
    type: SET_BANNER,
    resolve,
    reject,
    body,
});

const userReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_USER:
            return {};
        case actionKey.success(GET_USER):
            return action.payload.user;
        default:
            return state;
    }
};
const bannerReducer = (state = {}, action) => {

    switch (action.type) {
        case SET_BANNER:
            if (action.body.key === 'BannerMessage') {
                return { bannerMessage: action.body.value, maintenance: "1" }
            }
            return { maintenance: action.body.value }
        case actionKey.success(SET_BANNER):
            return true;
        default:
            return state;
    }
};

const loading = (state = {}, action) => {
    switch (action.type) {
        case GET_USER:
            return true;
        case actionKey.success(GET_USER):
        case actionKey.failure(GET_USER):
            return false;
        default:
            return state;
    }
};

const error = (state = {}, action) => {
    switch (action.type) {
        case GET_USER:
        case actionKey.success(GET_USER):
            return null;
        case actionKey.failure(GET_USER):
            return action.error;
        default:
            return state;
    }
};

export default combineReducers({
    user: userReducer,
    showBanner: bannerReducer,
    loading,
    error,
});


export function* rootSaga() {
    yield [
        takeEvery(SEARCH_DOMAIN, searchDomain),
        takeEvery(INVITE_USER, inviteUser),
        takeEvery(MOVE_USER, moveUser),
        takeEvery(ADD_USER, addUser),
        takeEvery(SEND_FORM, sendForm),
        takeEvery(VALIDATE_USER, validateUser),
        takeEvery(DELETE_USER, deleteUser),
        takeEvery(REMOVE_USER_FROM_COMPANY, removeFromCompany),
        takeEvery(EDIT_USER, editUser),
        takeEvery(GET_USER, getUser),
        takeEvery(SET_BANNER, setBanner),
    ];
}

/**
 * REDUX SAGAS
 */

function* getUser({ type, userId }) {
    yield call(request, {
        url: `/api/administration/user/${userId}`,
        type,
    });
}

function* addUser({
    type,
    body,
    resolve,
    reject,
}) {
    const result2 = yield call(request, {
        url: '/api/administration/user',
        type,
        options: {
            method: 'POST',
            body,
        },
    });

    if (result2.error) {
        reject(new SubmissionError({
            _error: result2.error,
        }));
        return;
    }
    resolve();

    yield put(showAlert({
        type: 'success',
        title: 'User Added',
        button: 'Done',
    }));
}

function* validateUser({
    type,
    body,
    resolve,
    reject,
}) {
    const result = yield call(request, {
        url: '/api/administration/validate-user',
        type,
        options: {
            method: 'PUT',
            body,
        },
    });

    if (result.error && reject) {
        reject(new SubmissionError({
            _error: result.error,
        }));
        return;
    }
    if (!result.error && resolve) {
        resolve();
        yield put(showAlert({
            type: 'success',
            title: 'User Updated',
            button: 'Done',
        }));
    }
}

function* deleteUser({
    type,
    body,
    resolve,
    reject,
}) {
    const result = yield call(request, {
        url: '/api/administration/delete-user',
        type,
        options: {
            method: 'PUT',
            body,
        },
    });

    if (result.error && reject) {
        reject(new SubmissionError({
            _error: result.error,
        }));
        return;
    }
    if (!result.error && resolve) {
        resolve();
        yield put(showAlert({
            type: 'success',
            title: 'User Deleted',
            button: 'Done',
        }));
    }
}

function* inviteUser({ type, body, resolve, reject }) {
    const result = yield call(request, {
        url: '/api/administration/user/invite',
        type,
        options: {
            method: 'POST',
            body,
        },
    });

    if (result.error) {
        reject(new SubmissionError({
            _error: result.error,
        }));
        return;
    }
    resolve();

    yield put(showAlert({
        title: 'Invite Sent',
        type: 'success',
        message: 'They will need to create their account to get started.',
        button: 'Done',
    }));
}

export function* upgradeUser({ user, body }) {
    const { promise, resolve } = PromiseCreator();
    yield put(openPromptAction({
        resolve,
        title: 'Upgrade this User?',
        message: 'upgrade-user',
        props: { user },
        okButton: 'Upgrade',
        primary: 'ok',
        showLoading: true,
    }));

    const upgrade = yield promise;
    if (upgrade) {
        const result = yield editUser({
            type: EDIT_USER,
            body,
            userId: user.userID_PK,
        });
        if (result.error) {
            yield put(showPromptErrorAction(result.error));
            yield upgradeUser({ user, body });
            return;
        }
    }
    yield put(closePromptAction());
}

export function* editUser({ type, body, id, resolve, reject }) {
    const result = yield call(request, {
        url: `/api/administration/user/${id}`,
        type,
        options: {
            method: 'PUT',
            body,
        },
    });
    if (result.error && reject) {
        reject(new SubmissionError({
            _error: result.error,
        }));
    } else if (!result.error && resolve) {
        resolve();
    }
    return result;
}

export function* sendForm({ type, body, resolve, reject }) {
    const result = yield call(request, {
        url: '/api/administration/company-form-client',
        type,
        options: {
            method: 'POST',
            body,
        },
    });
    if (result.error && reject) {
        reject(new SubmissionError({
            _error: result.error,
        }));
    } else if (!result.error && resolve) {
        yield put(showAlert({
            title: 'Organization created successfully',
            type: 'success',
            message: "The introductory email has been sent to the organization's main contact",
            button: 'Finish',
        }));
        resolve();
    }
    return result;
}

function* removeFromCompany({ type, user: { id, emailAddress } }) {
    const { promise, resolve } = PromiseCreator();

    yield put(openPromptAction({
        resolve,
        title: 'Remove This User',
        message: 'remove-user',
        props: { emailAddress },
        okButton: 'Remove',
        primary: 'ok',
        showLoading: true,
    }));

    const remove = yield promise;
    if (remove) {
        const result = yield call(request, {
            url: `/api/administration/user/${id}`,
            type,
            options: {
                method: 'DELETE',
            },
        });
        if (result.error) {
            yield put(showPromptErrorAction(result.error));
            yield removeFromCompany({ type, user: { id, emailAddress } });
            return;
        }
    }

    yield put(closePromptAction());
}

function* searchDomain({ type, payload, reject, resolve }) {
    if (!payload) {
        resolve();
        return;
    }
    const result = yield call(request, {
        url: `/api/administration/company-search/?q=${payload}`,
        type,
    });
    if (result && result.error) {
        reject(result.error);
    } else if (result) {
        const select = result.payload.companys.map(({
            companyID_PK, companyDomain }) => // eslint-disable-line camelcase
            ({ label: companyDomain,
                id: companyID_PK, // eslint-disable-line camelcase
            }));
        resolve({
            options: select,
        });
    } else {
        reject(new Error('Something went wrong'));
    }
}

export function* moveUser({ type, body, resolve, reject }) {
    const result = yield call(request, {
        url: '/api/administration/move-users',
        type,
        options: {
            method: 'PUT',
            body,
        },
    });
    if (result.error && reject) {
        reject(new SubmissionError({
            _error: result.error,
        }));
    } else if (!result.error && resolve) {
        resolve();
        yield put(showAlert({
            title: 'User moved',
            type: 'success',
            message: 'Users moved with success.',
            button: 'Ok',
        }));
        yield delay(2000);
        yield put(changeFilterAction({ userType: 'usermove' }));
    }
    return result;
}

export function* setBanner({ type, body, resolve, reject }) {
    const result = yield call(request, {
        url: '/api/setting',
        type,
        options: {
            method: 'POST',
            body,
        },
    });
    if (result.error && reject) {
        reject(new SubmissionError({
            _error: result.error,
        }));
    } else if (!result.error && resolve) {
        if (body.key === 'BannerMessage') {
            yield put(showAlert({
                title: 'Warning message has been updated',
                type: 'success',
                button: 'Finish',
            }));
        }
        resolve();
    }
    return result;
}




// WEBPACK FOOTER //
// ./src/client/redux/admin.js